var retrieveAnswer = function (answers) {
    var formattedAnswers = answers.map(function (answer) {
        if (typeof answer === 'string') {
            return answer;
        }
        return answer.text;
    });
    return formattedAnswers.join(', ');
};
export var formatDisputeDetails = function (transaction) {
    var _a = transaction || {}, merchantName = _a.merchantName, questionnaire = _a.questionnaire, statusDescription = _a.statusDescription;
    if (questionnaire) {
        var disputeDetailsArray_1 = [
            ['', statusDescription],
            ['Purchase', merchantName || '']
        ];
        questionnaire.forEach(function (question) {
            return disputeDetailsArray_1.push([
                question.questionText,
                retrieveAnswer(question.answers)
            ]);
        });
        return disputeDetailsArray_1;
    }
    return [
        ['', statusDescription],
        ['Purchase', merchantName]
    ];
};
//# sourceMappingURL=helpers.js.map